import React, { Component } from 'react'
import '../css/components/Status.scss'
import moment from 'moment-timezone'
import classnames from 'classnames'
import Spinner from './Spinner'
import {Thresholds} from '../constants/thresholds'

interface StatusProps {
  title: string
  value: number
  unit: string
  time: any
  error: boolean
  fetching: boolean
  thresholds: Thresholds
  reverseThresholds: boolean
}

interface StatusState {
  update: boolean
  absoluteTime: boolean
}

class Status extends Component<StatusProps, StatusState> {
  constructor(props:StatusProps) {
    super(props)
    this.state = {
      update: true,
      absoluteTime: false,
    }
  }

  componentDidUpdate(oldProps: StatusProps) {
    const {value} = this.props
    if (oldProps.value !== value && value) {
      this.triggerValueChange()
    }
  }

  toggleTime = () => {
    this.setState({
      absoluteTime: !this.state.absoluteTime,
    })
  }

  getTimeClass() {
    return classnames('time', {
      'no-time': !this.props.time,
    })
  }

  getValueClasses() {
    return classnames('value', {
      'value-update': this.state.update,
    })
  }

  triggerValueChange() {
    this.setState({
      update: true,
    })
    setTimeout(() => {
      this.setState({
        update: false,
      })
    }, 1000)
  }

  getIndicatorClass() {
    const { value, thresholds, reverseThresholds, error } = this.props
    const statusIndicatorClass = 'status-indicator'

    if (!thresholds || error) {
      return statusIndicatorClass
    }

    const comparison = reverseThresholds ? value * -1 : value

    return classnames(
      statusIndicatorClass,
      { high: comparison >= thresholds.high },
      {
        moderate:
          comparison >= thresholds.moderate && comparison < thresholds.high,
      },
      {
        medium:
          comparison >= thresholds.medium && comparison < thresholds.moderate,
      },
      { low: comparison < thresholds.medium }
    )
  }

  render() {
    const { title, value, unit, time, error, fetching } = this.props
    const momTime = moment.utc(time).tz(moment.tz.guess())
    const { absoluteTime } = this.state

    return (
      <div className="status">
        <div className={this.getIndicatorClass()}>
          <h3 className="title">{title}</h3>
          {fetching && <Spinner size="8" />}
          {Boolean(value) && !fetching && !error && (
            <h1 className={this.getValueClasses()}>
              {value} {unit}
            </h1>
          )}
          {(error || !value) && !fetching && <h1>N/A</h1>}
          <h4 className={this.getTimeClass()} onClick={this.toggleTime}>
            {!time || !momTime.isValid()
              ? '-'
              : absoluteTime
              ? momTime.format('D.M.YYYY H:mm')
              : momTime.fromNow()}
          </h4>
        </div>
      </div>
    )
  }
}

export default Status
